<template>
    <div>
      <h3 class="Navigation-styles-nav-section-title" id="top-nav-list-title" v-html="(compact) ? t.all : t.top_sports">
  
      </h3>
      <ul class="NavigationList-styles-navigation-list" v-if="sport">
        <li v-for="s in sortAByKey(sport, 'Order').slice(0, 6)">
          <div class="CollapsibleItem-styles-collapsible-item">
            <div class="">
              <div id="1101" class="NavigationItemSimple-styles-navigation-item" @click="collapse(s)">
                <div class="NavigationItemSimple-styles-container">
                  <img class="NavigationItemSimple-styles-icon" onerror="this.style.display='none'" :src="'/static/assets/img/'+s.Alias+'.png'" alt="Fußball" loading="lazy" width="20" height="20">
                  <span class="">
                  <a class="" href="javascript:;">{{ s.Sport }}</a></span></div>
              </div>
            </div>
            <div :class="(s.collapse) ? 'NavigationItem-styles-navigation-item-wrapper' : 'CollapsibleItem-styles-closed NavigationItem-styles-hidden'">
  
              <ul class="NavigationList-styles-navigation-list">
                <li v-for="r in sortAByKey(s.region, 'Order')">
                  <div class="" @mouseover="hover(r)"
                       @mouseout="unhover(r)">
                    <div class="">
                      <div class="click-area"></div>
                      <div @click="collapseRegion(r)" id="navigation-multi-select-link-30201" class="NavigationItemMultiSelectLink-styles-navigation-item NavigationItemMultiSelectLink-styles-navigation-child-item">
                        <div class="NavigationItemMultiSelectLink-styles-container">
                          <div class="NavigationItemMultiSelectLink-styles-checkbox-container" :class="r.class1">
                            <input type="checkbox" v-model="r.selected" @change="selectedRegion(r.competition, r.ID)" class="Checkbox-styles-checkbox NavigationItemMultiSelectLink-styles-checkbox" id="30201" readonly="" title="Alles auswählen">
                          </div>
                          <span class="NavigationItemMultiSelectLink-styles-icon flag-ico" :class="'flag-'+r.Region.toLowerCase()+' '+r.class1" ></span>
                          <span class="">
                            <a class="" v-tooltip="r.Region" v-show="(r.Region.length > 10)" href="javascript:;">{{ r.Region }}...</a>
                            <a class="" v-show="(r.Region.length <= 10)" href="javascript:;">{{ r.Region }}</a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="NavigationItem-styles-navigation-item-wrapper" v-show="r.collapse">
                    <ul class="NavigationList-styles-navigation-list">
                      <li>
                        <div id="navigation-item-link-42301" class="NavigationItemLink-styles-item">
                          <label class="NavigationItemLink-styles-label">
                            <input type="checkbox" @change="selectedRegion(r.Competition, r.regionId, true)" class="Checkbox-styles-checkbox NavigationItemLink-styles-checkbox" id="42301" readonly="">
                            <a class="NavigationItemLink-styles-title" href="javascript:;">Select All</a>
                            <span class="NavigationItemLink-styles-badge">{{ r.eventCount }}</span></label>
                        </div>
                      </li>
                      <li v-for="c in r.Competition">
                        <div id="navigation-item-link-42301" class="NavigationItemLink-styles-item">
                          <div class="clicka" @click="selectedEvent(c.ID)"></div>
                          <label class="NavigationItemLink-styles-label">
                            <input type="checkbox" :id="'r'+c.ID" value="on"
                                   :class="'competition-checkbox-'+r.regionId" class="Checkbox-styles-checkbox NavigationItemLink-styles-checkbox" readonly=""/>
                            <a class="NavigationItemLink-styles-title">{{ c.Competition }}</a>
                            <span class="NavigationItemLink-styles-badge">{{ c.Count }}</span>
                          </label>
                        </div>
                      </li>
                    </ul>
  
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
  
      <h3 class="Navigation-styles-nav-section-title" id="top-nav-list-title" v-html="(compact) ? t.all : t.all_sports">
      </h3>
      <ul class="NavigationList-styles-navigation-list" v-if="sport">
        <li v-for="s in sortAByKey(sport, 'Order').slice(6)">
          <div class="CollapsibleItem-styles-collapsible-item">
            <div class="">
              <div id="1101" class="NavigationItemSimple-styles-navigation-item" @click="collapse(s)">
                <div class="NavigationItemSimple-styles-container">
                  <img class="NavigationItemSimple-styles-icon" onerror="this.style.display='none'" :src="'/static/assets/img/'+s.Alias+'.png'" alt="Fußball" loading="lazy" width="20" height="20">
                  <span class="">
                  <a class="" href="javascript:;">{{ s.Sport }}</a></span></div>
              </div>
            </div>
            <div :class="(s.collapse) ? 'NavigationItem-styles-navigation-item-wrapper' : 'CollapsibleItem-styles-closed NavigationItem-styles-hidden'">
  
              <ul class="NavigationList-styles-navigation-list">
                <li v-for="r in sortAByKey(s.region, 'Order')">
                  <div class="" @mouseover="hover(r)"
                       @mouseout="unhover(r)">
                    <div class="">
                      <div class="click-area"></div>
                      <div @click="collapseRegion(r)" id="navigation-multi-select-link-30201" class="NavigationItemMultiSelectLink-styles-navigation-item NavigationItemMultiSelectLink-styles-navigation-child-item">
                        <div class="NavigationItemMultiSelectLink-styles-container">
                          <div class="NavigationItemMultiSelectLink-styles-checkbox-container" :class="r.class1">
                            <input type="checkbox" v-model="r.selected" @change="selectedRegion(r.competition, r.ID)" class="Checkbox-styles-checkbox NavigationItemMultiSelectLink-styles-checkbox" id="30201" readonly="" title="Alles auswählen">
                          </div>
                          <span class="NavigationItemMultiSelectLink-styles-icon flag-ico" :class="'flag-'+r.Region.toLowerCase()+' '+r.class1" ></span>
                          <span class="">
                            <a class="" v-tooltip="r.Region" v-show="(r.Region.length > 10)" href="javascript:;">{{ r.Region }}...</a>
                            <a class="" v-show="(r.Region.length <= 10)" href="javascript:;">{{ r.Region }}</a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="NavigationItem-styles-navigation-item-wrapper" v-show="r.collapse">
                    <ul class="NavigationList-styles-navigation-list">
                      <li>
                        <div id="navigation-item-link-42301" class="NavigationItemLink-styles-item">
                          <label class="NavigationItemLink-styles-label">
                            <input type="checkbox" @change="selectedRegion(r.Competition, r.regionId, true)" class="Checkbox-styles-checkbox NavigationItemLink-styles-checkbox" id="42301" readonly="">
                            <a class="NavigationItemLink-styles-title" href="javascript:;">Select All</a>
                            <span class="NavigationItemLink-styles-badge">{{ r.eventCount }}</span></label>
                        </div>
                      </li>
                      <li v-for="c in r.Competition">
                        <div id="navigation-item-link-42301" class="NavigationItemLink-styles-item">
                          <div class="clicka" @click="selectedEvent(c.ID)"></div>
                          <label class="NavigationItemLink-styles-label">
                            <input type="checkbox" :id="'r'+c.ID" value="on"
                                   :class="'competition-checkbox-'+r.regionId" class="Checkbox-styles-checkbox NavigationItemLink-styles-checkbox" readonly=""/>
                            <a class="NavigationItemLink-styles-title">{{ c.Competition }}</a>
                            <span class="NavigationItemLink-styles-badge">{{ c.Count }}</span>
                          </label>
                        </div>
                      </li>
                    </ul>
  
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'topSports',
    data () {
      return {
        t: this.$root.t,
        item: 999999,
        sport: null,
        sport2: null,
        isHovering: [],
        checkBoxClass: {},
        compact: false,
        selectedCompetitions: []
      }
    },
    watch: {
      '$store.state.fixtureTimeperiod' () {
        this.fetchCompetitions();
      }
    },
    mounted () {
      this.fetchCompetitions();
  
      var th = this
      this.$bus.$on('compact', (payload) => {
  
        th.compact = payload;
  
      });
    },
    methods: {
      selectedRegion(competitions, rid, all = false){
  
        Object.values(competitions).forEach(
            val => {
              val.selected = (val.selected) ? false : true;
              val.selected = (all) ? true : val.selected
              this.selectedEvent(val.ID)
            }
        )
        //this.selectedEvent()
  
        //this.CheckUncheckAllAndExcludeDisabledByClass('', 'competition-checkbox-'+rid)
  
      },
      selectedEvent(e){
  
        var ina = 'r'+e;
  
          if(this.selectedCompetitions.includes(e)){
            var index = this.selectedCompetitions.indexOf(e);
            if (index !== -1) {
              this.selectedCompetitions.splice(index, 1);
              document.getElementById(ina).checked = false;
            }
          }else {
            this.selectedCompetitions.push(e);
            document.getElementById(ina).checked = true;
  
          }
    
          setTimeout(() => {
            var comp = this.selectedCompetitions.join(',')
            this.$router.replace({name: 'Sportsbook', query: {c: comp} })
          }, 500);
  
  
          //this.$bus.$emit('selectedCompetitions', this.selectedCompetitions);
          this.$store.commit("updateFixtureCompetitions", this.selectedCompetitions);
          this.$store.commit("updateCompetitionSelect", (this.$store.state.competitionSelect) ? 0 : 1);
  
      },
      collapse (s) {
        s.collapse = (s.collapse) ? false : true;
        this.fetchRegion(s.ID).then(response => {
            s.region = response.body.result
            comp = []
            response.body.result.forEach((v,i) => {
                    v.collapse = false
                    v.comp = []
                    comp.push(v)
            })
            return comp
        })
      },
      collapseRegion(r) {
        r.collapse = (r.collapse) ? false : true;
        r.class1 = (s.collapse) ? 'NavigationItemMultiSelectLink-styles-is-hovered' : '';
        this.$http.get(bsapi + 'api/v2/fixture/count?full=1&list=competition&region='+r.ID, {
          params: {
            app: this.$root.app.id,
            withoutMatch: 1,
            upcoming: this.$store.state.fixtureTimeperiod,
            v: 5
          }
        }).then(response => {
            r.Competition = []
            r.Competition = response.body.result
        })
      },
      hover(r){
        r.class1 = 'NavigationItemMultiSelectLink-styles-is-hovered';
      },
      unhover(r){
        r.class1 = '';
      },
      async fetchRegion(id) {
        return this.$http.get(bsapi + 'api/v2/fixture/count?full=1&list=region&sport='+id, {
          params: {
            app: this.$root.app.id,
            withoutMatch: 1,
            upcoming: this.$store.state.fixtureTimeperiod,
            v: 5
          }
        })
      },
      async fetchCompetitions() {
  
        var th = this;
        this.$http.get(bsapi + 'api/v2/fixture/count', {
          params: {
            app: this.$root.app.id,
            withoutMatch: 1,
            upcoming: this.$store.state.fixtureTimeperiod,
            v: 5
          }
        }).then(response => {
          // get body data
  
          th.sport = []
          response.body.result.forEach((v,i) => {
                v.collapse = false
                v.region = []
                th.sport.push(v)
          })
  
          var t = new Date();
          t.setSeconds(t.getSeconds() + 60);
  
          //window.currentEvents.data = vats;
          //window.currentEvents.time = t.getSeconds();
  
          if (th.item === 999999) {
            //th.$bus.$emit('FixtureEvents', th.sport);
          }
  
        }, response => {
          //th.$bus.$emit('FixtureEvents', null);
        })
      },
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  .NavigationItemMultiSelectLink-styles-is-hovered .NavigationItemMultiSelectLink-styles-icon{
    display: none !important;
  }
  .NavigationItemLink-styles-label {
    margin-bottom: 0px;
  }
  
  .NavigationItemMultiSelectLink-styles-icon {
    width: 20px;
    height: 20px;
    top: 0;
    left: 0px;
  }
  
  .NavigationItemLink-styles-item {
    position:relative;
    overflow: hidden;
  }
  .clicka{
    width: 100%;
    height: 100%;
    position: absolute;
    cursor: pointer;
  }
  </style>  


// WEBPACK FOOTER //
// src/components/widget/topSports.vue